import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, Show } from '@nu-art/thunderstorm-frontend/index';
import { compare, filterDuplicates } from '@nu-art/ts-common';
import { ModuleFE_FocusedObject } from '../modules/ModuleFE_FocusedObject.js';
import { Component_AccountThumbnail, ModuleFE_Account } from '@nu-art/user-account-frontend/index';
import './Component_FocusedEntityRef.scss';
export class Component_FocusedEntityRef extends ComponentSync {
    // ######################## Lifecycle ########################
    __onFocusedDataReceived(map) {
        this.reDeriveState();
    }
    deriveStateFromProps(nextProps, state) {
        state.focusedEntities = nextProps.focusedEntities;
        state.ignoreCurrentUser = nextProps.ignoreCurrentUser;
        state.accountIds = state.focusedEntities?.reduce((accountIds, focusedEntity) => {
            const accountIdsForFocusedItem = ModuleFE_FocusedObject.getAccountIdsForFocusedItem(focusedEntity.dbKey, focusedEntity.itemId, state.ignoreCurrentUser);
            return filterDuplicates([...accountIds, ...accountIdsForFocusedItem]);
        }, []) || [];
        return state;
    }
    /**
     * Mount / Unmount logic handled in
     * - ComponentWillUnmount
     * - ComponentDidMount
     * - ComponentDidUpdate
     *
     * It must be the case, in order for un-focusing and focusing to happen in the correct order
     * no matter how the component is rendered or recycled.
     */
    componentWillUnmount() {
        if (this.state.focusedEntities)
            ModuleFE_FocusedObject.unfocus(this.state.focusedEntities);
    }
    componentDidMount() {
        //If mounted with focus entities, focus on them
        if (this.state.focusedEntities)
            ModuleFE_FocusedObject.focus(this.state.focusedEntities);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        //Change in focused entities, set new focused
        if (!compare(prevState.focusedEntities, this.state.focusedEntities)) {
            //Unfocus previous entities
            if (this.state.focusedEntities)
                ModuleFE_FocusedObject.unfocus(this.state.focusedEntities);
            //focus current entities
            if (prevState.focusedEntities)
                ModuleFE_FocusedObject.focus(prevState.focusedEntities);
        }
    }
    // ######################## Render ########################
    render() {
        return _jsx(LL_H_C, { className: 'component--focused-object', children: this.state.accountIds.map(id => {
                const account = ModuleFE_Account.cache.unique(id);
                return _jsxs(Show, { children: [_jsx(Show.If, { condition: !!account, children: _jsx(Component_AccountThumbnail, { accountId: () => id }) }), _jsx(Show.Else, { children: _jsx("div", { children: "Bug" }) })] }, id);
            }) });
    }
}
//# sourceMappingURL=Component_FocusedEntityRef.js.map